import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { IncomeEffects, incomeReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([IncomeEffects]), StoreModule.forFeature(`income`, incomeReducer)]
})
export class IncomeStateModule {}
